<template>
  <div class="container">
    <!-- --------------------- PAGE HEADER ---------------------- -->
    <div class="view-header mt-3">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Factura de Compra</h1>
          <p class="view-header__subtitle">Registrá los datos de la factura y los productos de la compra.</p>
        </div>
      </div>
    </div>

    <!-- --------------------- CABECERA ---------------------- -->
    <receipt-header
      @headerchanged="headerUpdated"
      :show-pricelist="showPricelist"
      :show-prices="showPrices"
      :show-choosedate="showChoosedate"
      :show-pos="showPos"
      :numbers="numbers"
      :salespoints="salespoints"
      :invoicem="invoicem"
      :pos_default="pos_default"
      :config="config"
      :pricelist_default="pricelist_default"
      :client_default="client_default"
      :company_typetax="company_typetax"
    />

    <!-- --------------------- PRODUCTOS ---------------------- -->
    <receipt-products
      v-if="payload.header.loadproducts"
      :config="config"
      :show-taxes="showTaxes"
      :show-prices="showPrices"
      :show-barcodes="showBarcodes"
      @productschanged="productsUpdated"
      @sendProduct="sendProduct"
      :product_default="client_default"
      :disciva="disciva"
      :allow_sale_without_stock="allow_sale_without_stock"
      :prexistprd="prexistprd"
    />

    <!-- --------------------- NOTAS ---------------------- -->
    <div class="form-card">
      <div class="form-card__header">
        <h2 class="form-card__title">
          <i class="bi bi-pencil-square"></i>
          Notas de la compra
        </h2>
      </div>
      <div class="form-card__body">
        <textarea
          v-model="payload.saleNote"
          name="note"
          class="form-control"
          rows="3"
          maxlength="500"
          placeholder="Ingresá alguna observación o nota adicional (opcional)"
        ></textarea>
        <div class="form-card__hint text-right">{{ (payload.saleNote || '').length }} / 500</div>
      </div>
    </div>

    <!-- --------------------- TOTALES ---------------------- -->
    <receipt-totals v-if="showTotals" :totals="payload.totals" @totalschanged="totalsUpdated"/>

    <!-- --------------------- BOTON FINAL ---------------------- -->
    <div class="my-4 text-right">
      <button
        type="button"
        class="form-card__btn form-card__btn--primary"
        :disabled="!(payload.totals.total > 0) || !totalUpperToSixDigit"
        @click="showPaymentmethods ? showModal = true : sendReceipt()"
      >
        <i class="bi bi-save"></i>
        Guardar factura
      </button>
    </div>

    <pay-order-payment-methods
      :disciva="disciva"
      :fundDefault="config.fund_default"
      :header="payload.header"
      @paymentmethodschanged="paymentMethodsUpdated"
      @paymentmethodsclose="paymentMethodsClose"
      v-bind:payment-methods="payment_methods"
      v-bind:total="payload.total"
      v-if="showModal"
      @close="showModal = false"
      :limited="false"
    />
  </div>
</template>

<script>
import receiptProducts from './Receipt-products.vue';
import receiptHeader from './Receipt-header.vue';
import receiptTotals from './Receipt-totals.vue';
import payOrderPaymentMethods from '../../../paymentmethods/Pay-order-payment-methods.vue';

  export default {
    props: [
          'config','branchofficeData',
          'client_default', 'product_default', 'pricelist_default',
          'company_typetax', 'payment_methods', 'pos_default', 'note_default',
          'showPrices', 'showBarcodes', 'showPaymentmethods', 'debug',
          'showPos', 'showPricelist', 'showTaxes', 'showChoosedate', 'prexistprd',
          'numbers', 'salespoints', 'invoicem', 'allow_sale_without_stock', 'endpointurl','showTotals'
    ],
    data: function() {
      return {
        showModal: false,
        disciva: false,
        products: [],
        payload: {
          header: {},
          items: [],
          totals: {
            gross: 0,
            taxes: {
              two: 0,
              five: 0,
              ten: 0,
              twentyOne: 0,
              twentySeven: 0,
              lofty: 0,
              internalTax: 0,
              perceptionTax: 0,
              iibb: 0,
              otherTax: 0
            },
            total: 0,
            discount: 0,
          },
          saleNote: this.note_default,
        },
        modalProduct: false,
      }
    },
    computed: {
      showPayButton(){
        return this.showPaymentmethods && this.payload.totals.total>0 && 
          this.totalUpperToSixDigit && this.headerState;
      },
      headerState(){
        var number = this.payload.header.number;
        var pos = this.payload.header.pos;
        return number!= null && !isNaN(number) && number.length>0 &&
          pos!= null && !isNaN(pos) && pos.length>0 &&
          this.payload.header.provider_id!=null && this.payload.header.letter!=null
      },
      paymentMethods(){
        return this.payment_methods 
      },
      hasProducts(){
        return (this.payload.items.length>0);
      },
      totalUpperToSixDigit() {
        if (this.payload.total >= 9999999999999.99) {
          alert('Se pasó el límite de $9.999.999.999.999,99, por favor ingrese menos productos.');
          return false;
        } else {
          return true;
        }
      }
    },
    methods: {
      calcprod : function() {
        var app = this;
        for (var i = 0; i < app.products.length; i++) {
          if (app.products[i].includetax==1) {
            app.products[i].gross = app.products[i].price / (1+(app.products[i].taxtype/100));
          } else {
            app.products[i].gross = app.products[i].price;
          }
          app.products[i].tax = app.products[i].gross * app.products[i].taxtype/100;
        }
      },
      sendReceipt: function() {
        var app=this;
        for (var i = 0; i < app.payload.items.length; i++) {
          delete app.payload.items[i].code;
          delete app.payload.items[i].barcode;
          delete app.payload.items[i].stock;
        }
        if (app.debug) {console.log(app.payload);}
        this.$http.post(app.endpointurl, app.payload)
        .then(function (response) {
          if (response.data.success) {
           alert(response.data.data.responseText);
           if (!app.debug) {window.location.href = window.location.pathname;}
         } else {
           alert(response.data.message);
         }
        })
        .catch(function (error) {
          console.log(error.data);
          alert(error.data.message);
        });
      },
      headerUpdated: function(obj) {
        var app = this;
        app.payload.header = obj;
        if (app.payload.header.letter=="A" || app.payload.header.letter=="M") {
          app.disciva=true;
        } else {
          app.disciva=false;
        }
        app.calcprod();
      },
      paymentMethodsUpdated: function(obj) {
        var vm = this;
        vm.payload.paymentMethods = obj;
        console.log(vm.payload);
      },
      paymentMethodsClose: function(obj) {
        this.paymentMethodsUpdated(obj);
        this.productsUpdated(this.products);
        this.sendReceipt();
      },
      productsUpdated: function(obj) {
        this.payload.items = obj;
        this.products = obj;
        this.calcprod();
      },
      totalsUpdated: function(obj) {
        var app = this;
        app.payload.totals = obj
        app.payload.total = obj.total
        app.payload.subtotal = obj.gross
        app.payload.discount = obj.discount
      },
      sendProduct(product) {
        this.products.push(product);
        this.productsUpdated(this.products);
      }
    },
    components: {
      receiptProducts,
      receiptHeader,
      receiptTotals,
      payOrderPaymentMethods
    }
  }
</script>

<style lang="css">
  

  .note-client {
    margin-top: 15px;
  }

  .activate-payment {
    margin-top:8px;
    text-align: right;
  }
</style>
